import * as React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Box, StepConnector, stepConnectorClasses, StepIconProps, styled } from '@mui/material';
import { Check, ClearSharp, MoreHorizOutlined, HourglassTopRounded} from '@mui/icons-material';

import colors from '../../../../assets/theme/base/colors';
import { DateHelper } from '../../../Model/helpers';
import { VerificationClientStatusState } from '../../../../Modules/Common/StaticData/VAClientStatus';
const { primary, grey, dark , warning , error ,success} = colors;

const CustomIcon = styled('div')<{ ownerState: { state: VerificationClientStatusState } }>(
    () => ({
        color: grey[100],
        display: 'flex',
        height: 22,
        alignItems: 'center',
    }),
);

interface ICustomStepProps extends StepIconProps{ state: VerificationClientStatusState}

const CustomStep = (props: ICustomStepProps) => {
    const { state, className } = props;
    return (
        <CustomIcon ownerState={{ state }} className={className}>
            {state === VerificationClientStatusState.Complete || state === VerificationClientStatusState.Not_Applicable ? (
                <div style={{
                    backgroundColor: '#fff',
                    borderColor: primary.main,
                    zIndex: 1,
                    width: 35,
                    height: 35,
                    display: 'flex',
                    borderRadius: '50%',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <Check style={{ color: success.main}} />
                </div>

            ) : state === VerificationClientStatusState.Terminated ? (
                <div style={{
                    backgroundColor: 'white',
                    borderColor: primary.main,
                    zIndex: 1,
                    width: 35,
                    height: 35,
                    display: 'flex',
                    borderRadius: '50%',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <ClearSharp style={{ color: error.main}} />
                </div>
            ) : state === VerificationClientStatusState.In_Progress_Stage_1 || state === VerificationClientStatusState.In_Progress_Stage_2 ? (
                    <div style={{
                        backgroundColor: 'white',
                        borderColor: primary.main,
                        zIndex: 1,
                        width: 35, 
                        height: 35, 
                        display: 'flex',
                        borderRadius: '50%',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                            <HourglassTopRounded style={{ color: warning.main }} />
                    </div>                            
            ) : (
                <div style={{
                    backgroundColor: 'white',
                    borderColor: primary.main,
                    zIndex: 1,
                    width: 35,
                    height: 35,
                    display: 'flex',
                    borderRadius: '50%',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>                  
                </div>
            )}
        </CustomIcon>
    );
}

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: grey[100],
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

export interface ISteps {
    id: number;
    recordId: number;
    state: number;
    completed: boolean ;
    dateAchieved?: Date;
    label: string;
    description: any;
}

interface IProps {
    steps: ISteps[];
    onStepClick?: (id: number) => void;
}

export const StatusStepper = (props: IProps) => {
    return (
        <Box sx={{ width: '100%' }} >
            <Stepper alternativeLabel connector={<CustomStepConnector />} >
                {props.steps.map((step, index) => (
                    <Step key={index} completed={step.completed}>
                        <StepLabel StepIconComponent={(stepIconProps) => <CustomStep {...stepIconProps} state={step.state} />}>
                            <Box display="flex" alignItems="center" flexDirection="column">
                                <a href="#" onClick={() => props.onStepClick && props.onStepClick(step.id!)} style={{ textDecoration: 'none', color: step.completed ? 'white' : dark.main }}>
                                    {step.label}
                                </a>
                                {step.dateAchieved && step.completed && <span>{DateHelper(step.dateAchieved)}</span>}
                            </Box>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box >
    );
}